<template>
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="el-card pd20 search">
      <div class="search-box">
        <!-- 使用状态 -->
        <label>使用状态：</label>
        <el-select v-model="searchStatus" placeholder="请选择使用状态" clearable>
          <el-option label="未使用" value="0">未使用</el-option>
          <el-option label="已使用" value="1">已使用</el-option>
          <el-option label="已失效" value="-1">已失效</el-option>
        </el-select>

        <el-button type="primary" class="btn" @click="pullData" round size="small">查&nbsp;&nbsp;询</el-button>
        <el-button @click="exportExcelHandle()" round size="small">导&nbsp;&nbsp;出</el-button>
      </div>
    </div>
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="code"  label="兑换码"></el-table-column>
          <el-table-column label="用户昵称/头像">
            <template  slot-scope="scope">
              <div v-if="scope.row.headimgurl" class="userinfo">
                <img :src="scope.row.headimgurl" />
                {{scope.row.nickname}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="测评产品名称"></el-table-column>
          <el-table-column prop="use_count" label="使用状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status==-1" type="info">已失效</el-tag>
              <el-tag v-if="scope.row.status==0">未使用</el-tag>
              <el-tag v-if="scope.row.status==1" type="success">已使用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="use_time" label="使用时间"></el-table-column>
          <el-table-column  label="操作">
            <template slot-scope="scope">
                <el-button type="info" size="mini" icon="el-icon-share"
                    v-clipboard:copy="scope.row.code"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    circle
                ></el-button>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
        </el-table>
      </div>
      <!-- 返回 -->
      <el-button type="info" class="goBack" size="mini"   @click="$router.go(-1);" >返回</el-button>
      <!-- 分页 -->
      <el-pagination
        class="pages"
        :page-sizes="[25, 50, 75, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="pages.size"
        :current-page="pages.page"
        background
        layout="sizes,prev, pager, next"
        :total="pages.count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { codeuseList,exportCodeuseList } from "@/api/measurement";
import { exportExcel } from "@u/tools";
export default {
  data() {
    return {
      list: [],
      pages: {},
      searchStatus: null
    };
  },
  methods: {
    onCopy: function (e) {
      this.$message.success('复制成功，直接粘贴即可！');
    },
    onError: function (e) {
      this.$message.error('复制失败，请重试！');
    },
    /*
     *@param:
     *@return:
     *@Description:导出使用记录
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-18 14:32:26
     */
    exportExcelHandle() {
        let obj = {
            group_id: this.$route.query.group_id
        };
        if (this.searchStatus) {
            obj["status"] = parseInt(this.searchStatus);
        }
        let h = ['用户昵称','兑换码','测评产品名称','使用状态','使用时间','创建时间','备注'];
        let b =  ['nickname','code','name','status','use_time','create_time','remark'];
        
        exportCodeuseList(obj).then((res)=>{
            let list = res.list;  //把data里的tableData存到list
            for(let key in list){
                // 类型转换
                if(list[key].status ==-1){
                    list[key].status =  '已失效';
                }
                if(list[key].status ==0){
                    list[key].status =  '未使用';
                }
                if(list[key].status ==1){
                    list[key].status =  '已使用';
                }
            }
            exportExcel(h,b,list,'测评-生成试用链接')
        
        })
    },
    // 调整每页显示条数
    handleSizeChange(val) {
      this.pages.size = val;
      this.pullData();
    },
    // 触发分页
    handleCurrentChange(val) {
      this.pages.page = val;
      this.pullData();
    },
    // 初始化获取数据
    pullData() {
      this.$showLoading();
      let obj = {
        group_id: this.$route.query.group_id,
        page: this.pages ? this.pages.page : null, //页码，默认1
        size: this.pages ? this.pages.size : null //每页数量，默认25
      };
      if (this.searchStatus) {
        obj["status"] = parseInt(this.searchStatus);
      }
      codeuseList(obj)
        .then(data => {
          this.list = data.list;
          this.pages = data.pager;
          this.$hideLoading();
        })
        .catch(err => {
          this.$hideLoading();
        });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
}
.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages {
  text-align: right;
  margin-top: 30px;
}
.goBack{
  position: absolute;
  left: 0px;
  bottom: 0;
}
.search {
  margin-bottom: 20px;
  .search-box {
    display: flex;
    align-items: center;
    label {
      font-size: 16px;
      color: #606266;
    }
    .on {
      margin: 0 80px;
    }
    .btn {
      margin-left: auto;
    }
  }
}
.userinfo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
}
</style>
<style lang="scss">
.search-box {
  .el-input {
    width: 300px;
  }
}
</style>
